import { FormsHelpers, FormsEntities, FormsActionTypes } from '@bimser/common';
import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { createSyncAction, MLHelper } from '@bimser/core';
import { put } from 'redux-saga/effects';

export function* runShowMessageAction(
	action: RuleEngineLegacyEntities.IShowMessageAction,
	windowId: string
) {
	switch (action.dialogType) {
		case 'Toaster': {
			FormsHelpers.showToasterMessage(
				MLHelper.isMLEmpty(action.messages) ? action.name : action.messages,
				action.alertType,
				null,
				action.highlightList
			);
			break;
		}
		case 'Popup': {
			FormsHelpers.showPopupMessage(action.name, action.alertType, action.messages);
			break;
		}
		case 'Summary': {
			const payload: FormsEntities.IShowSummaryMessagePayload = {
				windowId,
				messages: [
					{
						title: action.name,
						type: action.alertType,
						message: action.messages
					}
				]
			};

			const summaryMessagesAction = createSyncAction(
				FormsActionTypes.SHOW_SUMMARY_MESSAGES,
				FormsEntities.ShowSummaryMessagePayloadFactoryFromJS(payload)
			);
			yield put(summaryMessagesAction);

			break;
		}
		default:
			console.warn('The action type that you trying to run is not found!');
	}
}
